module.exports = __webpack_public_path__ + "img/XRP.84ce7542.svg";